import React, { FC } from 'react';
import { TableProps, Table, Skeleton, Space, Tooltip, Button, Popconfirm } from 'antd';

import { IOfferRecommendation } from 'types/recommendations.types';
import { getOptionLabel } from 'utils/format';
import { useAppSelector } from 'store';
import { citiesSelector } from 'store/dictionaries/dictionaries.selectors';
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

type Props<T> = Pick<TableProps<T>, 'onChange' | 'pagination' | 'loading'> & {
  items: T[];
  onEdit: (item: T) => void;
  onDelete: (item: T) => void;
};

export const OffersTable: FC<Props<IOfferRecommendation>> = ({
  onChange,
  items,
  pagination,
  loading,
  onEdit,
  onDelete,
}) => {
  const { options: cities, loading: citiesLoading } = useAppSelector(citiesSelector);
  return (
    <Table
      rowKey={'id'}
      loading={loading}
      dataSource={items}
      pagination={pagination}
      onChange={onChange}
      columns={[
        {
          dataIndex: 'title',
          title: 'Заголовок',
          align: 'center',
        },
        {
          dataIndex: 'description',
          title: 'Описание',
          align: 'center',
        },
        {
          dataIndex: 'cityIds',
          title: 'Города',
          align: 'center',
          render: (cityIds: IOfferRecommendation['cityIds']) => {
            if (citiesLoading) return <Skeleton.Button />;
            const cityNames = (cityIds || []).map((cityId) => getOptionLabel(cities, cityId));
            return cityIds ? cityNames.join(', ') : '';
          },
        },
        {
          title: 'Действия',
          align: 'center',
          render: (_, data) => (
            <Space>
              <Tooltip title="Редактировать">
                <Button type="text" icon={<EditOutlined />} onClick={() => onEdit(data)} />
              </Tooltip>
              <Popconfirm
                placement="topRight"
                title="Подтвердите действие"
                onConfirm={() => onDelete(data)}
                zIndex={2}
                okText={''}
                cancelText={''}
                okButtonProps={{
                  icon: <CheckOutlined />,
                  size: 'small',
                  danger: true,
                }}
                cancelButtonProps={{
                  icon: <CloseOutlined />,
                  size: 'small',
                }}
              >
                <Tooltip title="Удалить" zIndex={1}>
                  <Button type="text" icon={<DeleteOutlined />} />
                </Tooltip>
              </Popconfirm>
            </Space>
          ),
        },
      ]}
    />
  );
};
